<template>
    <div class="wrap" ref="container">
        <router-link
            :to="{ path: '/news/detail/' + item.id }"
            class="item"
            v-for="(item, index) in lists"
            :key="index"
        >
            <div class="title">{{ item.title }}</div>
            <div class="time">{{ item.create_time }}</div>
        </router-link>
        <van-loading v-if="!loadend">
            {{ $t('loading') }}
        </van-loading>
        <van-empty
            description="暂无任何内容"
            :image="require('@images/nodata.png')"
            v-if="lists.length === 0 && page > 1"
        />
    </div>
</template>
<script>
import { getArticleList } from '@api/public';

export default {
    name: 'NewsList',
    props: {},
    data: function() {
        return {
            page: 1,
            limit: 10,
            loadTitle: '',
            loading: false,
            loadend: false,
            lists: [],
            active: 0,
            cid: 1
        };
    },
    mounted: function() {
        this.cid = this.$route.params.cid || 1;
        this.active = this.getActiveId(this.cid);
        this.getArticleLists();
        this.$scroll(this.$refs.container, () => {
            !this.loading && this.getArticleLists();
        });
    },
    watch: {
        $route(n) {
            if (n.name === 'NewsList') {
                this.cid = n.params.cid || 1;
                this.active = this.getActiveId(this.cid);
                this.page = 1;
                this.loaded = false;
                this.loading = false;
                this.$set(this, 'lists', []);
                this.getArticleLists();
            }
        }
    },
    methods: {
        getArticleLists: function() {
            let that = this;
            if (that.loaded == true || that.loading == true) return;
            that.loading = true;
            let q = {
                page: that.page,
                limit: that.limit
            };
            getArticleList(q, that.cid).then(res => {
                that.loading = false;
                //apply();js将一个数组插入另一个数组;
                that.lists.push.apply(that.lists, res.data);
                that.loadend = res.data.length < that.limit; //判断所有数据是否加载完成；
                that.page = that.page + 1;
            });
        },
        itemClick(key) {
            this.active = key;
            this.cid = this.getCateId(key);
            let params = this.$router.history.current.params;
            let newQuery = JSON.parse(JSON.stringify(params));
            if (this.cid != newQuery.cid) {
                this.$router.push({ path: '/news_list/' + this.cid });
            } else {
                this.page = 1;
                this.loaded = false;
                this.loading = false;
                this.$set(this, 'lists', []);
                this.getArticleLists();
            }
        },
        getCateId(key) {
            var cid;
            switch (key) {
                case 2:
                    cid = 7;
                    break;
                case 1:
                    cid = 6;
                    break;
                default:
                    cid = 1;
                    break;
            }
            return cid;
        },
        getActiveId(cid) {
            var index;
            cid = parseInt(cid) || 1;
            switch (cid) {
                case 7:
                    index = 2;
                    break;
                case 6:
                    index = 1;
                    break;
                default:
                    index = 0;
                    break;
            }
            return index;
        }
    }
};
</script>
